/* eslint-disable no-alert */
import {
  DocumentRequest,
  EmailRequest,
  FormRequest,
  LetterRequest,
} from "../types";
import { buildMailTo } from "../utils";

export const useCorrespondence = () => ({
  email: (request: EmailRequest) => window.open(buildMailTo(request)),
  letter: (request: LetterRequest) => {
    alert(`Opening letter:
      matter id: ${request.matterId}
      recipients: ${request.to?.map(({ entityId }) => entityId).join(", ")}
      body: ${request.body}
    `);
  },
  document: (request: DocumentRequest) => {
    alert(`Opening document:
      matter id: ${request.matterId}
      title: ${request.title}
      body: ${request.body}
    `);
  },
  form: (request: FormRequest) => {
    alert(`Opening form:
      matter id: ${request.matterId}
      title: ${request.title}
      body: ${request.body}
    `);
  },
});
